import { SxProps, Stack, MenuItem, Typography, useTheme } from "@mui/material";
import { MenuItemType } from "./ActionsPopover.types";

type RowMenuProps = {
    menuItems: MenuItemType[];
};

const RowMenu = ({ menuItems }: Readonly<RowMenuProps>) => {
    const theme = useTheme();

    const itemStyle: SxProps = {
        padding: theme.spacing(0.75),
    };

    return (
        <>
            <Stack direction="column" gap="20px" useFlexGap>
                {menuItems.map((item, index) => (
                    <MenuItem
                        key={`popover-${index}`}
                        onClick={item.onClick}
                        sx={itemStyle}
                        disabled={!!item.isDisabled}
                    >
                        {item.icon}
                        <Typography sx={theme.custom.rowMenuElement}>{item.label}</Typography>
                    </MenuItem>
                ))}
            </Stack>
        </>
    );
};

export default RowMenu;
